import { Component, inject } from '@angular/core';
import { InternalOrderService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InternalOrderCreateDto,
  InternalOrderDto,
  InternalOrderExcelDownloadDto,
  InternalOrderUpdateDto,
} from '../proxy/controlling/dtos/internal-order';
import { INTERNALORDER_CONFIG, INTERNALORDER_FIELDS } from './internal-order.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-internal-order',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InternalOrderService, ConfirmationService],
  templateUrl: './internal-order.html',
  styleUrl: './internal-order.scss',
})
export class InternalOrder extends BaseCrudComponent<
  InternalOrderDto,
  InternalOrderCreateDto,
  InternalOrderUpdateDto,
  InternalOrderExcelDownloadDto
> {
  service = inject(InternalOrderService);
  config = INTERNALORDER_CONFIG;
  fields = INTERNALORDER_FIELDS;

  protected prepareUpdateDto(data: any, selected: InternalOrderDto): InternalOrderUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      oldSapCode: data.oldSapCode,
      isVisible: data.isVisible,
      internalOrderTypeId: data.internalOrderTypeId,
      projectTypeId: data.projectTypeId,
      oldCostCenterId: data.oldCostCenterId,
      costCenterId: data.costCenterId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InternalOrder';
  }
}
